import {urlByLang} from './urlByLang';

export const replaceLocale = (path: string, newLocale: string, currentLocale?: string): string => {
    const newUrl = urlByLang(newLocale);
    return path.replace(`/${urlByLang(currentLocale) || window.CURRENT_LOCALE}`, newUrl === '' ? '' : `/${newUrl}`);
};
